import React from 'react'
import { Provider } from 'react-redux'

import RootContainer from './RootContainer'

export default class AppContainer extends React.Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    const { store } = this.props

		return (
			<Provider store={store}>
				<RootContainer
					{...this.props}
				/>
			</Provider>
		)
  }
}
